export enum SubscriptionAdminFilterKey {
  Status = 'status',
}

export const SUBSCRIPTION_ADMIN_FILTER_KEYS = Object.values(SubscriptionAdminFilterKey);
